<template>
    <loPage>
        <loSection>
            <loArticle>
                <mdCartCaption
                    :caption="$t('popup.signin.caption.register')"
                    :needBottomLine="false"
                ></mdCartCaption>
                <div class="md singup">
                    <div class="fieldset">
                        <label>
                            {{ $t('page.profile.item.titlecn') }}
                            <cpStatus
                                themes="danger"
                                text="*"
                            ></cpStatus>
                        </label>
                        <div class="cp input text" :class="[errors.has('companyNameZh')? 'is-error': '']" :data-error="errors.first('companyNameZh')">
                            <input v-model="companyNameZh" type="text" v-validate="'required'" name="companyNameZh" id="companyNameZh">
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>
                            {{ $t('page.profile.item.titleen') }}
                        </label>
                        <div class="cp input text" :class="[errors.has('companyNameEn')? 'is-error': '']" :data-error="errors.first('companyNameEn')">
                            <input v-model="companyNameEn" type="text" v-validate="" name="companyNameEn" id="companyNameEn">
                        </div>
                    </div>
                    <div class="center">
                        <div class="left">
                            <div class="fieldset">
                                <label>
                                    {{ $t('page.profile.item.companyrep') }}
                                    <cpStatus
                                        themes="danger"
                                        text="*"
                                    ></cpStatus>
                                </label>
                                <div class="cp input text" :class="[errors.has('principal')? 'is-error': '']" :data-error="errors.first('principal')">
                                    <input v-model="principal" type="text" v-validate="'required'" name="principal" id="principal">
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('site.noun.phone') }}</label>
                                <div class="cp input text" :class="[errors.has('phoneNumber')? 'is-error': '']" :data-error="errors.first('phoneNumber')">
                                    <input v-model="phoneNumber" type="text" v-validate="" name="phoneNumber" id="phoneNumber">
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>
                                    E-mail
                                    <cpStatus
                                        themes="danger"
                                        text="*"
                                    ></cpStatus>
                                </label>
                                <div class="cp input text" :class="[errors.has('email')? 'is-error': '']" :data-error="errors.first('email')">
                                    <input v-model="email" type="email" v-validate="'required'" name="email" id="email">
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="fieldset">
                                <label>
                                    {{ $t('page.profile.item.businessregisration') }}
                                    <cpStatus
                                        themes="danger"
                                        text="*"
                                    ></cpStatus>
                                </label>
                                <div class="cp input text" :class="[errors.has('BusinessRegistrationCertificate')? 'is-error': '']" :data-error="errors.first('BusinessRegistrationCertificate')">
                                    <input v-model="BusinessRegistrationCertificate" type="text" v-validate="'required'" name="BusinessRegistrationCertificate" id="BusinessRegistrationCertificate">
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>
                                    {{ $t('page.profile.item.cell') }}
                                    <cpStatus
                                        themes="danger"
                                        text="*"
                                    ></cpStatus>
                                </label>
                                <div class="cp input text" :class="[errors.has('cellphoneNumber')? 'is-error': '']" :data-error="errors.first('cellphoneNumber')">
                                    <input v-model="cellphoneNumber" type="text" v-validate="'required'" name="cellphoneNumber" id="cellphoneNumber">
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>
                                    {{ $t('site.noun.taxid') }}
                                    <cpStatus
                                        themes="danger"
                                        text="*"
                                    ></cpStatus>
                                </label>
                                <div class="cp input text" :class="[errors.has('uniformNumber')? 'is-error': '']" :data-error="errors.first('uniformNumber')">
                                    <input v-model="uniformNumber" type="text" v-validate="'required'" name="uniformNumber" id="uniformNumber">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>
                            {{ $t('site.noun.service') }}
                        </label>
                        <div class="cp input textarea" :class="[errors.has('merchandise')? 'is-error': '']" :data-error="errors.first('merchandise')">
                            <textarea v-model="merchandise" v-validate="" name="merchandise" id="merchandise"></textarea>
                        </div>
                    </div>
                    <div class="fieldset" @click.prevent="selectClass">
                        <label>
                             {{ $t('page.profile.item.purchaseitem') }}
                            <cpStatus
                                themes="danger"
                                text="*"
                            ></cpStatus>
                        </label>
                        <div class="cp input div" :class="[WantToBuy.length? '': 'is-error']" :data-error="$t('page.register.status.selectone')">
                            <div :value="WantToBuy" type="text">
                                <span
                                    class="span"
                                    v-for="item in WantToBuy"
                                    :key="item"
                                    @click.prevent.stop="removeClass(item)"
                                >
                                    <cpStatus
                                        themes="info"
                                        icon="cancel"
                                        :text="item"
                                    ></cpStatus>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="btnArea">
                        <cpBtn
                            themes="major"
                            icon="person"
                            :text=" $t('site.func.register') "
                            extendClass="is-block"
                            @click.prevent="register"
                        ></cpBtn>
                    </div>
                </div>
            </loArticle>
        </loSection>
    </loPage>
</template>

<script>
    import loPage from '@/components/loPage'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import mdCartCaption from '@/components/mdCartCaption'
    import cpStatus from '@/components/cpStatus'
    import cpBtn from '@/components/cpBtn'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loPage,
            loSection,
            loArticle,
            mdCartCaption,
            cpStatus,
            cpBtn,
        },
        data: function(){

            return {
                companyNameZh: '',
                companyNameEn: '',
                principal: '',
                BusinessRegistrationCertificate: '',
                phoneNumber: '',
                cellphoneNumber: '',
                email: '',
                uniformNumber: '',
                merchandise: '',
                WantToBuy: [],
            }
        },
        computed: {
            ...mapState([
                'user',
                'langID',
                'token',
                'productList',
            ]),
            selectOption: function(){
                let $productList = this.productList || [],
                    $result = {}

                $productList.forEach(item => {
                    if( !$result[item.product_b] ) {
                        $result[item.product_b] = []
                    }

                    if( !$result[item.product_b].includes(item.product_m) ) {
                        $result[item.product_b].push(item.product_m)
                    }
                });

                return $result;
            },
            snlist: function(){
                let $productList = this.productList || [],
                    $WantToBuy = this.WantToBuy || [],
                    $result = []

                $WantToBuy.forEach(item => {
                    let $target = $productList.find(target => (target.product_b +'-'+ target.product_m) === item);

                    if( $target ) {
                        $result.push($target.product_sn);
                    }
                });

                return $result;
            }
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
                'pushNotification',
            ]),
            selectClass: function(){
                
                this.pushPopUp({
                    type: 'selectClass',
                    content:{
                        caption: this.$t('popup.register.caption.chooseitem'),
                        options: this.selectOption,
                        value: this.WantToBuy,
                        action: (val) => {
                            this.addClass(val);
                        }
                    }
                });
            },
            addClass: function(str){

                if( !this.WantToBuy.includes(str) ) {
                    this.WantToBuy.push(str);
                }
            },
            removeClass: function(str){
                let _index = this.WantToBuy.indexOf(str);

                this.WantToBuy.splice(_index, 1);
            },
            sendRegister: async function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Notify',
                        func: 'SalesmanByRegister',
                    }),
                    $condition = {
                        cufn: this.companyNameZh,
                        cufn_e: this.companyNameEn,
                        bos: this.principal,
                        certificate: this.BusinessRegistrationCertificate,
                        phone: this.phoneNumber,
                        cellphone: this.cellphoneNumber,
                        email: this.email,
                        rfno: this.uniformNumber,
                        magtit: this.merchandise,
                        snlist: this.snlist,
                        willingitem: this.WantToBuy.join(', '),
                    }

                try {
                    await this.$http.post(_url, $condition);

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.registersuccess'),
                        }
                    });

                    this.$router.push('/index');
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.sendRegister,
                    });
                }
            },
            register: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {

                        if( this.WantToBuy.length ) {
                            this.sendRegister();
                        }
                    }
                });
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.singup {
        @extend %card;
        max-width: 760px;
        margin: 0 auto;
        padding: $interval-l $interval-xl;

        .cp.input {

            > div, input, textarea {
                background-color: #fcfcfc;
            }
        }

        .center {
            display: flex;

            @include media('mobile') {
                display: block;
            }
        }

        .left {
            flex: 1;
            padding-right: $interval-s;

            @include media('mobile') {
                padding-right: 0;
            }
        }

        .right {
            flex: 1;
            padding-left: $interval-s;

            @include media('mobile') {
                padding-left: 0;
            }
        }

        .fieldset {
            padding: $interval-xs 0;
            margin-bottom: $interval-m;

            .cp.input {
                display: block;
                width: auto;

                > div, input, textarea {
                    width: 100%;

                    &[disabled] {
                        background-color: $white;
                        cursor: pointer !important;
                    }
                }

                textarea {
                    height: 80px;
                }
            }

            label {
                display: block;
                margin-bottom: $interval-xs;
            }
        }

        .span {
            cursor: pointer;

            &:hover {
                transition: $transition;
                opacity: $opacity-m;
            }
        }

        .btnArea {
            margin: $interval-xl auto 0;
            max-width: 200px;

            @include media('mobile') {
                margin: $interval-xl 0 0;
                max-width: none;
            }
        }
    }
</style>
 